import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'owner-header',
    templateUrl: './owner-header.component.html',
    styleUrls: ['./owner-header.component.scss'],
    standalone: false
})
export class OwnerHeaderComponent implements OnInit {
  @Input() owners: any;
  @Input() index: any;
  constructor() {}
  get ownerClass(): string {
    return this.index === 0 ? 'tap-main' : 'tap-spouse';
  }

  get owner(): UntypedFormGroup {
    return this.owners.controls[this.index] as UntypedFormGroup;
  }

  ngOnInit(): void {}
}
